import Card from '@/src/common/components/marketing/cards/Card'
import { BACStep1Body } from '@/src/modules/build-a-card/StyledComponents'
import { DesktopOnly } from '@/src/common/utilities/viewportDisplay'
import CtaButtons from '@/src/modules/gift-box/buttons/CtaButtons'
import ShippingAndUsageContent from '../../build-a-card/physical/content/ShippingAndUsageContent'

const BoxStep1LeftContent = ({
    defaultImage,
    designImage,
    designName,
}: {
    designImage: string
    defaultImage: string
    designName: string
}) => {
    const image = designImage ? designImage : defaultImage

    return (
        <>
            <h1 style={{ marginTop: 20 }}>
                Select how to send your{' '}
                <span className={'gradient'}>Visa gift card!</span>
            </h1>
            <Card
                size={'lg'}
                image={image}
                isExtended={!designImage}
                overlayType={'full'}
                message={'Custom message'}
                name={'Recipient name'}
                showLoader={!designName}
                priority={true}
                borderRadius={!designImage ? 0 : 12}
            />
            <BACStep1Body>
                <ShippingAndUsageContent showPredesignMessage={true} />
                <DesktopOnly>
                    <CtaButtons />
                </DesktopOnly>
            </BACStep1Body>
        </>
    )
}

export default BoxStep1LeftContent
